<template>
  <a :href="`${$prefix}/plants/${plant.id}`">
    <img
      :src="plant.thumbnail"
      class="rounded-t-lg"
      :alt="plant.species_scientific_name"
    />
    <div class="p-4 mb-2">
      <h6 class="font-bold font-sans-secondary">
        {{ plant.species_common_name }}
      </h6>
      <p class="italic font-medium text-gray-800 truncate opacity-75">
        {{ plant.species_scientific_name }}
      </p>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    plant: {
      type: Object,
      required: true,
    },
  },
};
</script>
